import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import SectionBase from '@cld/section';
import { typography } from '@cld/typography';
import { BaseSectionProps } from './common/BaseSectionProps';
import { SectionWrapper } from './common/SectionWrapper';

// TODO This is very hacky. Task for it: https://cloudinary.atlassian.net/browse/OTP-221
const SectionDecorated = styled(SectionBase)`
  summary div {
    ${typography.sm.highContrast};
  }
  summary svg {
    color: ${globalTheme.palette.contrastLow};
  }
`;

export interface CollapsibleSectionProps extends BaseSectionProps {
  onToggle?: (newState: boolean) => void,
}

export const CollapsibleSection: FC<CollapsibleSectionProps> = ({ title, children, highlight, noPadding, showHorizontalLine = true, onToggle }) => (
  <SectionWrapper highlight={highlight} showHorizontalLine={showHorizontalLine}>
    <SectionDecorated
      title={title}
      onToggle={onToggle}
      open
      horizontalPadding={noPadding ? 'none' : undefined}
      verticalPadding="md"
      data-test="cld-section"
    >
      {children}
    </SectionDecorated>
  </SectionWrapper>
);
